import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  StockTransferHistory: [],
  addData: {},
  allStockTransferStatus: [],
  sorted: [],
};

const slice = createSlice({
  name: 'StockTransfer',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET StockTransferManagement
    getStockTransfersSuccess(state, action) {
      state.data = action.payload.data;
    },

    // GET All StockTransfer Status Success
    getAllStockTransferStatusesSuccess(state, action) {
      state.getAllStockTransferStatus = action.payload.data;
    },

    // GET StockTransferManagement
    getStockTransfersHistorySuccess(state, action) {
      state.StockTransferHistory = action.payload.data;
    },

    addOrUpdateStockTransfers(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    addOrUpdateStockTransfersErrors(state, action) {
      state.addData = {
        data: action.payload,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      state.checkout.activeStep = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getStockTransfers() {
  return async () => {
    try {
      const response = await get(`StockTransfer`);
      if (response.status) {
        dispatch(slice.actions.getStockTransfersSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateStockStatus(body) {
  return async () => {
    try {
      const response = await put(`stock/updateStatus`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateStockTransfers(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function updateLatestAvailableTime(body) {
  return async () => {
    try {
      const response = await put(`stock/updateLatestAvailableTime`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateStockTransfers(response));
      } else {
        dispatch(slice.actions.addOrUpdateStockTransfersErrors(response));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllStockTransferStatus(location, limit, code) {
  return async () => {
    try {
      const response = await get(`get-all-StockTransfer-status`);
      if (response.status) {
        dispatch(slice.actions.getAllStockTransferStatusesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getStockTransferHistory(code) {
  return async () => {
    try {
      const response = await get(`StockTransfer-history?code=${code}`);
      if (response.status) {
        dispatch(slice.actions.getStockTransfersHistorySuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addStockTransferSender(body) {
  return async () => {
    try {
      const response = await post(`StockTransferSender`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateStockTransfers(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export function updateTransferReceived(body) {
  return async () => {
    try {
      const response = await put(`updateTransferReceived`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateStockTransfers(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
